/** @format */

import {parsePhoneValue} from '../../../components/form/handle_change';
import {InputWithErrorHandler} from '../../../components/form';
import {useSave} from 'frontier/components/form/use_save';
import {Checkbox} from '@sttark/design-system';
import {useFetch} from 'frontier-utilities';
import {handleChange} from 'frontier-form';
import update from 'immutability-helper';
import {If} from 'frontier-utilities';
import React, {useState} from 'react';

const UserTextSetting = props => {
    const {id} = props;

    const [state, setState] = useState({
        receive_text_updates: null,
        phone: null,
        error: null
    });

    const {isLoading: loading} = useFetch(
        '/account/users/edit-user-text-details/' + id,
        handleUserFetched
    );
    const {save, isSaving} = useSave('/account/users/edit-user-text-details/' + id, 1000);

    function handleUserFetched(response) {
        const {user} = response;

        if (!user) {
            setState(prev => ({
                ...prev,
                error: 'Unable to save. If you continue to experience this issue, please contact us.'
            }));
        } else {
            const user_detail = user?.user_detail || {};
            setState(prev => ({
                ...prev,
                receive_text_updates: user_detail.receive_text_updates,
                phone: user_detail.text_number,
                error: null
            }));
        }
    }

    const handleTextSettingChange = val => {
        save({
            user_detail: {
                phone: state.phone,
                receive_text_updates: val
            }
        });

        setState(prev => ({
            ...prev,
            receive_text_updates: val
        }));
    };

    const handlePhoneChange = updateTarget => {
        if (!updateTarget?.phone) return;

        setState(update(state, {...updateTarget}));

        let phone = updateTarget.phone['$set'];
        phone = phone.replaceAll('-', '');

        save({
            user_detail: {
                text_number: phone,
                receive_text_updates: state.receive_text_updates
            }
        });
    };

    if (loading) {
        return <div className="user-text-settings">Getting some settings for you...</div>;
    }

    return (
        <UserPhone
            handleTextSettingChange={handleTextSettingChange}
            onChange={handlePhoneChange}
            isSaving={isSaving}
            {...props}
            {...state}
        />
    );
};

const UserPhone = handleChange(props => {
    const {
        handleTextSettingChange,
        receive_text_updates,
        onPhoneInputChange,
        isSaving,
        error,
        phone
    } = props;

    const phoneNumber = parsePhoneValue(phone || '');

    return (
        <>
            <div className="account-preferences-section-10mc__row">
                <Checkbox
                    checked={receive_text_updates || false}
                    onChange={handleTextSettingChange}
                    bold={receive_text_updates}
                    style={{lineHeight: 1}}>
                    Opt-in to text notifications
                </Checkbox>
            </div>
            <If condition={receive_text_updates}>
                <div className="account-preferences-section-10mc__row">
                    <div className="form-group w-100">
                        <InputWithErrorHandler
                            onChange={onPhoneInputChange.bind(this, 'phone')}
                            className="form-control form-control-sm"
                            placeholder="Enter your phone number"
                            label="Primary contact phone number"
                            errorPath="text_number"
                            value={phoneNumber}
                            error={error}
                            newestds
                        />
                        <If condition={isSaving}>
                            <i className="fa fa-spinner fa-spin color-accent-primary d-inline-block me-2" />
                            <span className="color-accent-primary">Saving changes</span>
                        </If>
                    </div>
                </div>
            </If>
        </>
    );
});

export default UserTextSetting;
